import { useEffect, useState } from "react";
import { apiGet } from "../../client/apiClient.js";
import type { ApiResult, DaySlots } from "../../shared/types.js";
import { LoadingState } from "../../components/States.js";

export function TimeSlotSelector({
  date,
  selectedTime,
  onSelectTime,
  postalCode,
}: {
  date: string;
  selectedTime: string | null;
  onSelectTime: (time: string) => void;
  postalCode?: string;
}) {
  const [day, setDay] = useState<DaySlots | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiGet<ApiResult<DaySlots>>(`/api/availability/day?date=${date}${postalCode ? `&postalCode=${postalCode}` : ""}`).then((res) => {
      if (cancelled) return;
      if (res.ok) setDay(res.data);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [date, postalCode]);

  if (loading) return <LoadingState label="Tijdstippen worden geladen…" />;
  if (!day || !day.isOpen) return <p className="text-small">Geen inspecties beschikbaar op deze dag.</p>;

  const morning = day.slots.filter((s) => s.period === "voormiddag");
  const afternoon = day.slots.filter((s) => s.period === "namiddag");

  function renderGroup(label: string, slots: DaySlots["slots"]) {
    if (slots.length === 0) return null;
    return (
      <div className="timeslot-group">
        <h4>{label}</h4>
        <div className="timeslot-list" role="group" aria-label={label}>
          {slots.map((s) => (
            <button
              key={s.time}
              type="button"
              className="timeslot-btn"
              disabled={!s.available}
              aria-pressed={selectedTime === s.time}
              onClick={() => onSelectTime(s.time)}
            >
              {s.time}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      {renderGroup("Voormiddag", morning)}
      {renderGroup("Namiddag", afternoon)}
      <p className="text-tiny text-muted mt-4">De inspectie duurt gemiddeld 2 tot 3 uur.</p>
    </div>
  );
}
